import { AbstractGridListingFilter, type IGridListingFilterValue } from '../grid.listing.filter';

export type TDictItem = {
    name: string;
    id: number | string;
    key?: string;
};

interface ISelectedValue {
    value: number | string | (number | string)[];
}

export class DictionaryGridListingFilter extends AbstractGridListingFilter {
    private dict: TDictItem[];
    private dictName: string;

    constructor(
        private filterName: string,
        private fieldName: string,
        scopeVariable: ISelectedValue = null,
        private showFieldNameInBottom = false
    ) {
        super(filterName, scopeVariable);
    }

    public init(dict: TDictItem[] | string) {
        if (typeof dict === 'string') {
            this.dictName = dict;
        } else if (Array.isArray(dict)) {
            this.dict = dict;
        }
    }

    public values() {
        return [
            {
                name: this.fieldName,
                value: this.value()
            }
        ];
    }

    public value() {
        return this.scopeVariable.value;
    }

    public title() {
        const titles = [];
        let values;

        if (this.value()) {
            values = JSON.parse(JSON.stringify(this.value()));
        }
        if (values) {
            if (!Array.isArray(values)) {
                values = [values];
            }
            values.forEach(value => {
                if (this.dict) {
                    const dictItem: TDictItem = this.dict.find(_dictItem => _dictItem.id === value || _dictItem.key === value);
                    if (dictItem) {
                        titles.push(dictItem.name || dictItem.key || dictItem.id);
                    }
                } else if (this.showFieldNameInBottom) {
                    titles.push({ name: this.filterName, value: value });
                } else {
                    titles.push(value);
                }
            });
        }
        return titles;
    }

    public descriptions() {
        return (_values: IGridListingFilterValue[]) => {
            let titles = this.title();
            if (this.dict) {
                titles = (titles && titles.length && [titles.map(item => `<span i18n="${item}"></span>`).join(', ')]) || null;
            } else if (this.dictName) {
                const joinedTitle = titles &&
                    titles.length && [titles.map(item => `<span dictionary-value-view='${this.dictName}' value="'${item}'"></span>`).join(', ')];
                titles = joinedTitle || null;
            } else if (this.showFieldNameInBottom) {
                titles = titles && titles.length && [titles.map(item => `<span i18n="${item.name}"></span><span>${item.value}</span>`)];
            }
            if (!titles) return null;
            return {
                quick: this.quick,
                empty: this.noBottom,
                titles: titles
            };
        };
    }

    public isEmpty() {
        const value = this.value();
        if (Array.isArray(value)) {
            return !value || value.length == 0;
        }
        return !value;
    }

    public clear() {
        this.scopeVariable.value = '';
    }

    public detach(): void {
        super.detach();
        delete this.dict;
    }
}
